export default __webpack_public_path__ + "static/photo_quote-29f42ee1a5d403cf834fff247f9ee219.jpg";